export const en = {
    'request-error': 'Error occurred. Please try again.'
};
